import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import type { Column, ColumnsType } from '../utils/buildColumns'
import TimeOffCell from './TimeOffCell'

interface LeaveRowProps {
  columns: ColumnsType
}

const TimeOffRow = ({ columns }: LeaveRowProps) => {
  const [{ leaves, restDays }] = useSchedule()

  const cells = columns.slice(1)

  return (
    <>
      <WrapperCell sticky minWidth="s240">
        <Box
          background="grey000White"
          flexDirection="row"
          justifyContent="spaceBetween"
          height="full"
          paddingY="s8"
          paddingX="s16"
        >
          <Box flexDirection="row" alignItems="center" overflowX="hidden">
            <Text size="300" weight="medium" color="grey1000" ellipsis>
              {i18n.t('shift_management.time_off_row.title')}
            </Text>
          </Box>
        </Box>
      </WrapperCell>

      {cells.map((column: Column, columnIndex: number) => {
        return (
          <WrapperCell
            key={`TimeOffCell-${column.headerCell}-${columnIndex}`}
            minWidth={column.minWidth}
          >
            <TimeOffCell
              date={column.date}
              leaves={leaves?.filterByDate(column.date)}
              restDays={restDays?.filterByDate(column.date)}
            />
          </WrapperCell>
        )
      })}
    </>
  )
}

export default observer(TimeOffRow)
